import React from 'react';

import { Alert } from '@amzn/awsui-components-react-v3';

import { RFXAppLayout } from '../../components/RFXAppLayout';

/**
 * @returns Component that alerts the user they are not authorized to view
 * the selected page.
 */
const PageAccessAlert = () => {
  return <RFXAppLayout content={<Alert type="warning">You are not authorized to access the selected page.</Alert>} />;
};

export default PageAccessAlert;
